import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import {
  Accordion,
  Typography,
  mediaQuery,
  generatePadding
} from '@lacedltd/laced-components'

export const ProductUspList = styled.div({
  padding: `0 0 ${tokens.spacing[7]}`,

  [mediaQuery.m.min]: {
    paddingTop: tokens.spacing[7],
    borderTop: `${tokens.borderWidth.xs} solid ${tokens.color.airJordan[200]}`
  }
})

export const StyledAccordionRoot = styled(Accordion.Root)({
  padding: 0
})

export const AccordionTriggerImageWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: tokens.spacing[3]
})

export const ProductUspIcon = styled.img({
  height: '3rem'
})

export const PremiumShipIconWrapper = styled.div({
  height: '3rem',
  width: '3rem',
  display: 'grid',
  placeItems: 'center'
})

export const ProductUspTitle = styled(Typography.Heading)({
  fontSize: tokens.fontSize[3],
  marginBottom: 0
})

export const ProductUspTextWrapper = styled.div({
  padding: generatePadding('spacing.6', 'spacing.6', 'spacing.4')
})

export const PremiumDeliveryList = styled(Typography.Text)({
  listStyleType: 'initial',
  marginLeft: tokens.spacing[3]
})

export const ProductUspDescriptionParagraph = styled(Typography.Text)({
  display: 'block'
})

export const PremiumShipTerms = styled(Typography.Text)({
  margin: 0
})
